import { RenderViewSdgAlignmentsParams } from '@upright/common/renderer/component-types/types-render-view-sdg-alignments';
import { getRenderViewItemNameMaybe } from '@upright/ui/views/render-view/utils';

export function getRenderViewSdgDefaultTitle(params: RenderViewSdgAlignmentsParams) {
  return `${getRenderViewItemNameMaybe(params)} - UN SDG alignment`;
}
